import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { AppComponent } from '../../app.component';
import { ApiService } from '../../services/api.service';
import { PermissionsService } from '../../services/permissions.service';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';


@Component({
  selector: 'app-donation-list',
  templateUrl: './donation-list.component.html',
  styleUrls: ['./donation-list.component.scss']
})
export class DonationListComponent implements OnInit {

  
  public donationList: any;
  public from_date = moment(new Date()).format('YYYY-MM-DD');
  public to_date = moment(new Date()).format('YYYY-MM-DD');
  public payment_status = 'Pending';
  public onChangeSearch = new Subject<string>();
  public perPage = 20;
  public totalCount = 0;
  public page = 1;
  public maxDate =  ''; //moment(new Date()).format('YYYY-MM-DD');
  public is_paid = '';
  public allPaymentTypes:any = [];
  public payment_type_id = '';
  constructor(
    private apiService: ApiService,
    private appComponent: AppComponent,
    public permissionsService: PermissionsService,
    public router: Router
    
    ) { }

  ngOnInit() {
    this.getList('');
    this.getAllPaymentTypes();
  }

  navigateTo(url) {
    this.router.navigate([url]);
  }

  getList(_type) {
    this.appComponent.showLoader();
    const from_date = moment(this.from_date).format('YYYY-MM-DD');
    const to_date = moment(this.to_date).format('YYYY-MM-DD');
    this.apiService.getDataFromServer(`/donations?date=${from_date}&end_date=${to_date}&page=${this.page}&perpage=${this.perPage}&is_paid=${this.is_paid}&payment_type_id=${this.payment_type_id}`).subscribe(
      (res: any) => {
        this.donationList = res;
        this.appComponent.hideLoader();
        this.donationList.data.map(res => {
          res.created_at = moment.utc(res.created_at).local().format('DD-MM-YYYY h:mm a z');
          res.payment_detail = res.payment_details && res.payment_details.length ? res.payment_details[0] : null;
        });
        this.totalCount = res.total;
      },
      err => {
        console.log(err);
      }
    );
  }

  getAllPaymentTypes() {
    this.apiService.getDataFromServer('/payment_types').subscribe(
      res => {
        this.allPaymentTypes = res['data'];
      },
      err => {
        console.log(err);
      }
    );
  }

  public export() {
    const from_date = moment(this.from_date).format('YYYY-MM-DD');
    const to_date = moment(this.to_date).format('YYYY-MM-DD');
    this.appComponent.showLoader();
    this.apiService.getDataFromServer(`/export_donations?date=${from_date}&end_date=${to_date}&page=${this.page}&perpage=1000000&is_paid=${this.is_paid}&payment_type_id=${this.payment_type_id}`).subscribe((res: any) => {
      if(res.status_code === 200) {
        const fileArry =  res.data.split('/uploads/');
        this.apiService.getBlobFileFromServer(res.data).subscribe(res => {
          this.appComponent.hideLoader();
          let blob:any = new Blob([res], { type: res.type });
          const url = window.URL.createObjectURL(blob);
          let file_name = fileArry[fileArry.length - 1];
          saveAs(blob, file_name);
        }, (error) => {
        });
      } 
      this.appComponent.hideLoader();
    }, (error) => {
      this.appComponent.hideLoader();
      console.log('error' , error);
    });
  }


}

